import * as api from '../../../clients/kommunikation';

import {Action} from '@ngrx/store';

export const POST_UPDATE_SMTP_MANDANT_OPTIONS = '[KommunikationModul] PostUpdateSmtpMandantOptions laden';
export const POST_UPDATE_SMTP_MANDANT_OPTIONS_AUSFUEHREN = '[KommunikationModul] PostUpdateSmtpMandantOptions ausführen';
export const POST_UPDATE_SMTP_MANDANT_OPTIONS_ERFOLGREICH = '[KommunikationModul] PostUpdateSmtpMandantOptions laden erfolgreich';
export const POST_UPDATE_SMTP_MANDANT_OPTIONS_FEHLER = '[KommunikationModul] PostUpdateSmtpMandantOptions Ladefehler';
export const POST_UPDATE_SMTP_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT = '[KommunikationModul] PostUpdateSmtpMandantOptions nicht ausgeführt (evtl. Offline)';


export class PostUpdateSmtpMandantOptionsAction implements Action {
    readonly type = POST_UPDATE_SMTP_MANDANT_OPTIONS;
        constructor(public smtpMandantOptions: api.SmtpMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateSmtpMandantOptionsAusfuehrenAction implements Action {
    readonly type = POST_UPDATE_SMTP_MANDANT_OPTIONS_AUSFUEHREN;
        constructor(public smtpMandantOptions: api.SmtpMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateSmtpMandantOptionsErfolgreichAction implements Action {
    readonly type = POST_UPDATE_SMTP_MANDANT_OPTIONS_ERFOLGREICH;
        constructor(public smtpMandantOptions: api.SmtpMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateSmtpMandantOptionsFehlerAction implements Action {
    readonly type = POST_UPDATE_SMTP_MANDANT_OPTIONS_FEHLER;
        constructor(public payload: any, public smtpMandantOptions: api.SmtpMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateSmtpMandantOptionsNichtAusgefuehrtAction implements Action {
    readonly type = POST_UPDATE_SMTP_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type KommunikationCommandUpdateSmtpMandantOptionsActions =
    PostUpdateSmtpMandantOptionsAction
    | PostUpdateSmtpMandantOptionsAusfuehrenAction
    | PostUpdateSmtpMandantOptionsErfolgreichAction
    | PostUpdateSmtpMandantOptionsFehlerAction
    | PostUpdateSmtpMandantOptionsNichtAusgefuehrtAction
    ;
